
      import Invoice from './invoice.vue'
      import type { App, Plugin } from 'vue'

      export const InvoicePlugin: Plugin = {
        install(app: App) {
          app.component('Invoice', Invoice)
        },
      }
      export { Invoice }
      